import { render, staticRenderFns } from "./NewProfileMT.vue?vue&type=template&id=1fc6e66c&scoped=true&"
import script from "./NewProfileMT.vue?vue&type=script&lang=js&"
export * from "./NewProfileMT.vue?vue&type=script&lang=js&"
import style0 from "./NewProfileMT.vue?vue&type=style&index=0&id=1fc6e66c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc6e66c",
  null
  
)

export default component.exports